const apibasePathDevAdmin = process.env.REACT_APP_API_URL_ADMIN;

export const adminApi = {
    faq:`${apibasePathDevAdmin}/faq/list`,
    home:`${apibasePathDevAdmin}/home/landing-page`,
    cms:`${apibasePathDevAdmin}/pages/detail`,
    proclamation:`${apibasePathDevAdmin}/proclamation/list`,
    proclamationDetails:`${apibasePathDevAdmin}/proclamation/detail`,
    contact:`${apibasePathDevAdmin}/home/contact-us`
};